module.exports = __webpack_public_path__ + "static/media/2Bbase.1f9a3107.svg";